import { render, staticRenderFns } from "./ModalPrevent.vue?vue&type=template&id=676541ba&"
import script from "./ModalPrevent.vue?vue&type=script&lang=js&"
export * from "./ModalPrevent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports